module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/de.json
// module id = 548
// module chunks = 0